import React, { useEffect, useState } from 'react';
import TransactionItem from './TransactionItem';
import { db } from '../functions/firebaseFunctions';
import {FiChevronDown} from 'react-icons/fi';
import {getStripeCustomerID} from '../functions/firebaseFunctions';
import {getStripeAccountID} from '../functions/firebaseFunctions';

export default function Transactions(props) {
  const [customers, setCustomers] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [custID, setCustID] = useState(null);
  const [accID, setAccID] = useState(null);
  const [tab, setTab] = useState(custID ? 'Sent' : 'Received');
  const [page, setPage] = useState(1);
  const pageSize = 5;

  useEffect(() => {  
    async function getData() {    
      getStripeCustomerID().then(custResponse => {
        const customerID = custResponse.stripeCustomerID;
        if (custResponse.stripeCustomerID)
        { setCustID(customerID); } });
      getStripeAccountID().then(accResponse => {
        const accountID = accResponse.stripeAccountID;
        if (accResponse.stripeAccountID)
        { setAccID(accountID); } });
        console.log('custID', custID, 'accID', accID)
      const arrCust = [];
      const arrAcc = [];
        if (custID)
      {const customersSnapshot = await db.collection('transactions').doc('customers').collection(custID).get();
      customersSnapshot.forEach((doc) => {
        arrCust.push(doc.data());
      });
      setCustomers(arrCust);}
        if (accID)
      {const accountsSnapshot = await db.collection('transactions').doc('accounts').collection(accID).get();
      accountsSnapshot.forEach((doc) => {
        arrAcc.push(doc.data());
      });
      setAccounts(arrAcc);}
      
      setLoading(false);
    }
    getData();
  }, [custID, accID]);

  if (loading) {
    return <div style={{ display: 'flex', width: '100%', color: 'white', justifyContent: 'center'}}>Loading...</div>;
  }

  const displayedData = tab === 'Sent' ? customers : accounts;
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const displayedItems = displayedData.slice(0, endIndex);
  console.log(startIndex)

  const handleLoadMore = () => {
    setPage(page + 1);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', paddingInline: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
        <button
          style={{ borderWidth: 0, padding: 10, color: tab === 'Sent' ? 'white' : 'var(--ltg)' }}
          onClick={() => { setTab('Sent') }}>
          Sent
        </button>
        <button
          style={{ borderWidth: 0, padding: 10, color: tab === 'Received' ? 'white' : 'var(--ltg)' }}
          onClick={() => { setTab('Received') }}>
          Received
        </button>
      </div>
      {/* <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} /> */}
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      {tab === 'Sent' && !custID && <p style={{textAlign: 'center', color: 'var(--wht)', fontSize: 16}}>You do not have any transactions yet.</p>}
      {tab === 'Received' && !accID && <p style={{textAlign: 'center', color: 'var(--wht)', fontSize: 16}}>You do not have any transactions yet.</p>}
        {displayedItems.map(item => <TransactionItem item={item} key={item.id} />
        )}
        {displayedData.length > endIndex && 
          <button 
            style={{ marginHorizontal: 10, alignSelf: 'center', color: 'var(--wht)', borderWidth: 0}} 
            onClick={handleLoadMore}>
              Show more <FiChevronDown />
            </button>}
      </div>
    </div>
  );
}